'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function FOFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-jz9kwv8a2", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-ie3xul95z", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-68uc6d1mc" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-68uc6d1mc", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-jz9kwv8a2)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-68uc6d1mc" }), /* @__PURE__ */ React.createElement("g", { fill: "#f50100", stroke: "#2e42a5", strokeWidth: "2", mask: "url(#mantine-ie3xul95z)" }, /* @__PURE__ */ React.createElement("path", { d: "M15-1V9h18v6H15v10H9V15H-1V9H9V-1z" }))))
  );
}

export { FOFlag };
//# sourceMappingURL=FO.mjs.map
